import jstz from "jstz";

export class TimezoneHelper {
    public static getTimeZoneName() {
        var zonename = 'Local Standard Time';
        var timezone = jstz.determine();
        zonename = timezone.name();
        return zonename;
    }
}